import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const filesForRegister = api(({ searchTerm, skip, take, orderStmt, registerId }) =>
    !registerId
        ? null
        : query(
              gql`
                  query FilesForRegister(
                      $searchTerm: String
                      $skip: Int
                      $take: Int
                      $orderStmt: [String]
                      $registerId: String!
                  ) {
                      filesForRegister(
                          searchTerm: $searchTerm
                          skip: $skip
                          take: $take
                          orderStmt: $orderStmt
                          registerId: $registerId
                      ) {
                          totalCount
                          pageInfo {
                              endCursor
                              hasNextPage
                              hasPreviousPage
                              startCursor
                          }
                          edges {
                              node {
                                  importDate
                                  importedFrom
                                  importedBy
                                  fileType
                                  fileSize
                                  workbookIdentifier
                                  numberOfAssets
                              }
                              cursor
                          }
                      }
                  }
              `,
              { searchTerm, skip, take, registerId, orderStmt },
              { returns: "filesForRegister" }
          )
)
